export const CONFIG_STATE_LABELS = {
  live: 'Live',
  draft: 'Draft',
  needsAction: 'Needs action',
  deployed: 'Deployed',
  blocked: 'Blocked',
  deploying: 'Deploying',
  configured: 'Configured',
  missing: 'Missing',
  unknown: 'Unknown',
} as const;

export const CONFIG_SCOPE_LABELS = {
  edgeDevice: 'Edge device',
  cameraStream: 'Camera stream',
  zone: 'Zone',
  line: 'Line',
  area: 'Area',
  wholeArea: 'Whole area',
  noEdgeDevice: 'No edge device selected',
  noCameraStream: 'No camera stream selected',
  needsZoneScope: 'Needs zone scope',
  needsLineScope: 'Needs line scope',
} as const;
